import React, { FC, useState } from 'react';
import { Button } from 'flowbite-react';

import { CardContainer } from '../../../../layout';
import { InputLabel } from '../../../../components';
import { useGlobal } from '../../../../hooks/useGlobal';
import { sendMessage } from '../../../../services';
import { Msg } from '../../../../consts';

interface TestMessageFormProps {
  deviceId: string;
}

export const TestMessageForm: FC<TestMessageFormProps> = ({ deviceId }) => {
  const { showAlert } = useGlobal();
  const [sendMessagePayload, setSendMessagePayload] = useState<{
    phone: string;
  }>({
    phone: '',
  });
  const [sendMessageLoading, setSendMessageLoading] = useState<boolean>(false);

  const sendMessageHandler = async (
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    event.preventDefault();

    const { phone } = sendMessagePayload;

    const confirmAlert = await showAlert({
      text: `Bu numaraya ${phone} mesaj gönderilecek, onaylıyor musunuz?`,
      icon: 'question',
      showCancelButton: true,
    });

    if (confirmAlert.isConfirmed) {
      setSendMessageLoading(true);
      await sendMessage(deviceId, {
        phone,
        message: 'wpinvite bağlı cihaz test mesajı',
      })
        .then(() => {
          showAlert({
            text: Msg.MessageSendSuccess,
            icon: 'success',
          });
          setSendMessagePayload({ phone: '' });
        })
        .catch(() => {
          // TODO: error handler
        })
        .finally(() => {
          setSendMessageLoading(false);
        });
    }
  };

  return (
    <CardContainer title="Test Mesaj Gönder">
      <form onSubmit={sendMessageHandler}>
        <InputLabel
          containerClass="mb-4"
          title="Numara"
          onChange={(e: any) => {
            setSendMessagePayload({
              ...sendMessagePayload,
              phone: e.target.value,
            });
          }}
          value={sendMessagePayload.phone}
          required
          placeholder="905xxxxxxxxx"
        />
        <Button
          type="submit"
          color="blue"
          isProcessing={sendMessageLoading}
          disabled={sendMessageLoading}
        >
          Gönder
        </Button>
      </form>
    </CardContainer>
  );
};
